import { QrCode, TriangleAlert } from 'lucide-react';

interface ExpiredQrCodePosterProps {
  companyName: string;
  logoUrl: string | null;
}

export default function ExpiredQrCodePoster({ companyName, logoUrl }: ExpiredQrCodePosterProps) {
  return (
    <div className="min-h-screen bg-slate-100 p-3 sm:p-6 print:bg-white print:p-0">
      <style>{`
        @page { size: A4 portrait; margin: 10mm; }
        @media print {
          html, body, #root {
            width: auto;
            height: auto;
            min-height: 0 !important;
            margin: 0;
            background: white !important;
          }
          .expired-poster {
            box-sizing: border-box;
            width: 190mm !important;
            height: 270mm !important;
            min-height: 270mm !important;
            padding: 10mm !important;
            box-shadow: none !important;
          }
        }
        .expired-poster { print-color-adjust: exact; -webkit-print-color-adjust: exact; }
      `}</style>

      <article className="expired-poster mx-auto flex min-h-[297mm] w-full max-w-[210mm] flex-col bg-white p-6 text-slate-950 shadow-2xl sm:p-12 print:max-w-none">
        <header className="flex flex-col items-start gap-4 border-b-4 border-yellow-400 pb-5 sm:flex-row sm:items-center sm:gap-5">
          {logoUrl && <img src={logoUrl} alt={companyName} className="h-20 w-20 shrink-0 rounded-xl border border-slate-200 object-cover" />}
          <div className="min-w-0">
            <p className="mb-1 text-xs font-bold uppercase tracking-[0.18em] text-slate-500">Cadastro pelo app</p>
            <p className="break-words font-bebas text-5xl leading-none tracking-wide text-slate-950 sm:text-6xl">{companyName}</p>
          </div>
        </header>

        <main className="flex flex-1 items-center justify-center py-12 text-center">
          <div className="max-w-xl">
            <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-yellow-100 text-yellow-900">
              <TriangleAlert className="h-12 w-12" aria-hidden="true" />
            </div>
            <p className="mt-7 text-sm font-bold uppercase tracking-[0.18em] text-yellow-700">QR Code expirado</p>
            <h1 className="mt-2 text-balance font-bebas text-5xl leading-none tracking-wide text-slate-950 sm:text-6xl">Este cartaz não é mais válido</h1>
            <p className="mx-auto mt-5 max-w-lg text-pretty text-base leading-relaxed text-slate-600 sm:text-lg">
              A equipe gerou um novo QR Code. Peça o cartaz atualizado na recepção para entrar pelo blackbelts.app.
            </p>
          </div>
        </main>

        <footer className="flex items-center justify-center gap-2 border-t border-slate-200 pt-5 text-xs font-bold uppercase tracking-wider text-slate-500">
          <QrCode className="h-5 w-5 text-yellow-600" aria-hidden="true" />
          Solicite o QR Code atualizado
        </footer>
      </article>
    </div>
  );
}
